import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { documentRoute } from 'helpers/apiRoutes';
import { LoadPanel } from 'devextreme-react';
import { ProfileApis } from 'hooks/apis/ProfileApis';
import DocumentSection from 'components/common/DocumentSection';
import DocumentItem from 'components/common/DocumentItem';
import PageTitle from '../components/PageTitle';
import './Documents.scss';

const Documents = () => {
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const [accessLoading, setAccessLoading] = useState<boolean>(true);
  const { getUserHasAccess } = ProfileApis();

  useEffect(() => {
    getUserHasAccess()
      .then((data) => setHasAccess(data))
      .finally(() => setAccessLoading(false));
  }, [getUserHasAccess]);

  return (
    <>
      <PageTitle pageTitle="Documents" />
      <LoadPanel height={100} width={250} message="Checking document access" visible={accessLoading} />

      <Box className="documents">
        {!accessLoading && !hasAccess && (
        <Typography variant="body1">
          You do not currently have any clients assigned. Please contact your administrator.
        </Typography>
        )}

        {!accessLoading && hasAccess && (
        <DocumentSection title="Insurance">
          <DocumentItem
            title="Confirmation of Insurance PI"
            description="Confirmation of Insurance - Professional Indemnity"
            fileUrl={`${documentRoute}/download-company-document?folder=insurance&fileName=ConfirmationOfInsurance-PPL-10M.pdf`}
            fileName="ConfirmationOfInsurance10M.pdf"
          />
          <DocumentItem
            title="Confirmation of Insurance PPL"
            description="Confirmation of Insurance - Public & Products Liability"
            fileUrl={`${documentRoute}/download-company-document?folder=insurance&fileName=ConfirmationOfInsurance-PPL-20M.pdf`}
            fileName="ConfirmationOfInsurance20M.pdf"
          />
        </DocumentSection>)}
      </Box>
    </>
  );
};

export default Documents;